import {Component, Input, OnDestroy,} from '@angular/core';
import {takeUntil} from "rxjs/operators";
import {InfoMessage, InfoMessageData} from "../../interfaces/info-message";
import * as moment from "moment";
import {HttpClient} from "@angular/common/http";
import {Subject} from "rxjs";
import {BaseService} from "../../services/base.service";

@Component({
  selector: 'app-modal-history',
  templateUrl: './modal-history.component.html',
  styleUrls: ['./modal-history.component.scss']
})
export class ModalHistoryComponent extends BaseService implements OnDestroy {
  @Input()
  infoMessageList = [];

  public isDestroyed: Subject<boolean> = new Subject();
  public isModalHistoryShow: boolean = false;
  public infoMessageHistory: string = '';
  public isDarkBackground: boolean = false;

  constructor(
    private http: HttpClient
  ) {
    super();
  }

  openModalHistoryShow() {
    this.http.get(this.apiRoot + 'header/info_messages')
      .pipe(takeUntil(this.isDestroyed))
      .subscribe((data: InfoMessageData) => {
        this.infoMessageList = data.data;

        if (this.infoMessageList) {
          this.infoMessageList.forEach((message: InfoMessage) => {
            message.created = moment(message.created).format('DD.MM.YYYY HH:mm:ss');
            message.til = moment(message.til).format('DD.MM.YYYY');
            message.text = message.text.replace(/\d{4}-\d{2}-\d{2}/g, (date) => moment(date).format('DD.MM.YYYY'));
          });
        } else {
          this.infoMessageHistory = 'Повідомлення відсутні.';
        }
        this.isModalHistoryShow = true;
        this.isDarkBackground = true;
      });
  }

  deleteUserNotifyMess(id: number, index: number) {
    this.infoMessageList.splice(index, 1);

    this.http.post(this.apiRoot + 'header/delete_message', {
      message_id: id
    })
      .pipe(takeUntil(this.isDestroyed))
      .subscribe(() => {
      });
  }

  closeModal() {
    this.isModalHistoryShow = false;
    this.isDarkBackground = false;
  }

  ngOnDestroy() {
    this.isDestroyed.next(true);
    this.isDestroyed.complete();
  }
}
